export default {
  title: "الكوبونات",
  subtitle: "إدارة الكوبونات",
  
  addNew: "إنشاء كوبون جديد",
  createVoucher: "إنشاء كوبون",
  editVoucher: "تعديل كوبون",
  deleteVoucher: "حذف كوبون",
  
  fields: {
    code: "رمز الكوبون",
    name: "اسم الكوبون",
    description: "الوصف",
    type: "نوع الخصم",
    value: "قيمة الخصم",
    minOrderAmount: "الحد الأدنى لقيمة الطلب",
    maxDiscountAmount: "الحد الأقصى لقيمة الخصم",
    usageLimit: "حد الاستخدام",
    usageCount: "مرات الاستخدام",
    startDate: "تاريخ البداية",
    endDate: "تاريخ الانتهاء",
    isActive: "نشط",
    isPublic: "عام",
    autoApply: "تطبيق تلقائي",
    maxAmount: "الحد الأقصى لمبلغ الخصم",
    maxAmountHint: "-1 يعني غير محدود",
    applicableProducts: "المنتجات المطبقة",
    applicableCategories: "الفئات المطبقة",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  placeholders: {
    code: "أدخل رمز الكوبون (مثل: SAVE20)",
    name: "أدخل اسم الكوبون",
    description: "أدخل وصف الكوبون",
    value: "أدخل قيمة الخصم",
    minOrderAmount: "أدخل الحد الأدنى لقيمة الطلب",
    maxDiscountAmount: "أدخل الحد الأقصى لقيمة الخصم",
    usageLimit: "أدخل حد الاستخدام (0 للاستخدام غير المحدود)",
    maxAmount: "أدخل الحد الأقصى لمبلغ الخصم (-1 لغير محدود)",
    startDate: "اختر تاريخ البداية",
    endDate: "اختر تاريخ الانتهاء"
  },

  messages: {
    createSuccess: "تم إنشاء الكوبون بنجاح",
    createError: "فشل في إنشاء الكوبون",
    updateSuccess: "تم تحديث الكوبون بنجاح",
    updateError: "فشل في تحديث الكوبون",
    deleteSuccess: "تم حذف الكوبون بنجاح",
    deleteError: "فشل في حذف الكوبون",
    deleteConfirm: "هل أنت متأكد من حذف هذه الكوبون؟",
    noVouchers: "لا يوجد كوبون",
    loadingVouchers: "جاري تحميل الكوبون...",
    fetchError: "فشل في جلب الكوبون",
    fetchCustomersError: "فشل في جلب العملاء"
  },

  validation: {
    codeRequired: "رمز الكوبون مطلوب",
    codeMinLength: "رمز الكوبون يجب أن يكون 3 أحرف على الأقل",
    codeMaxLength: "رمز الكوبون يجب ألا يتجاوز 20 حرف",
    nameRequired: "اسم الكوبون مطلوب",
    typeRequired: "نوع الخصم مطلوب",
    valueRequired: "قيمة الخصم مطلوبة",
    valueMin: "قيمة الخصم يجب أن تكون أكبر من 0",
    startDateRequired: "تاريخ البداية مطلوب",
    endDateRequired: "تاريخ الانتهاء مطلوب",
    endDateAfterStart: "تاريخ الانتهاء يجب أن يكون بعد تاريخ البداية",
    minOrderAmountMin: "الحد الأدنى لقيمة الطلب يجب أن يكون 0 أو أكثر",
    usageLimitMin: "حد الاستخدام يجب أن يكون 0 أو أكثر"
  },
  
  table: {
    select: "اختيار",
    code: "الرمز",
    couponType: "نوع الكوبون",
    value: "القيمة",
    numberOfUse: "عدد مرات الاستخدام",
    maxAmount: "الحد الأقصى",
    from: "من",
    to: "إلى",
    isActive: "نشط",
    isPublic: "عام",
    isUsed: "مستخدم",
    customers: "العملاء",
    actions: "خيارات الأوامر"
  },
  
  types: {
    percent: "نسبة مئوية",
    amount: "مبلغ"
  },

  actions: {
    coupons: "الكوبونات",
    autoRefundCoupons: "كوبونات الاسترداد التلقائي",
    addNewCoupon: "إضافة كوبون جديد",
    edit: "تعديل",
    delete: "حذف",
    refresh: "تحديث",
    export: "تصدير",
    search: "البحث في الكوبونات...",
    filter: "تصفية"
  },

  status: {
    active: "نعم",
    inactive: "لا",
    unlimited: "غير محدود"
  },
  
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي الصلاحية",
    scheduled: "مجدول"
  },
  
  breadcrumbs: {
    vouchers: "كوبونات الخصم",
    create: "إنشاء كوبون",
    edit: "تعديل الكوبون",
    view: "عرض الكوبون"
  },

  buttons: {
    submit: "إرسال",
    update: "تحديث",
    submitting: "جاري الإرسال...",
    updating: "جاري التحديث...",
    backToIndex: "العودة للقائمة"
  }
};
